// store/thunks/auth/verifyRecoveryOtpThunk.ts
import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import type { RecoveryVerificationDTO } from '@/types/dtos.types';
import { sendRecoveryTwoFactorThunk } from '@/store/thunks/auth/sendRecoveryTwoFactorThunk';
import { isPhoneVerificationBypassToken } from '@/utils/phoneVerificationBypass';
import { normalizeEmail } from '@/utils/strings/strings';

export const verifyRecoveryOtpThunk = createAdminAsyncThunk<
  RecoveryVerificationDTO,
  { emailAddress: string; code: string },
  { rejectValue: { message: string } }
>(
  'auth/verifyRecoveryOtpThunk',
  async({ emailAddress, code }, { dispatch, extra: { authService }, rejectWithValue }) => {
    try {
      const result = await authService.verifyRecoveryOtp({
        emailAddress: normalizeEmail(emailAddress),
        code,
      });

      const recoveryToken = String(result.recoveryToken);

      if (!isPhoneVerificationBypassToken(recoveryToken)) {
        await dispatch(sendRecoveryTwoFactorThunk({ recoveryToken })).unwrap();
      }
      return result;
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send reset password email';
      return rejectWithValue({ message });
    }
  }
);
